// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "v2.53.0-7-g46b5ba42",
    "hash": "g46b5ba42",
    "distance": 7,
    "tag": "v2.53.0",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v2.53.0",
        "major": 2,
        "minor": 53,
        "patch": 0,
        "prerelease": [],
        "build": [],
        "version": "2.53.0"
    },
    "suffix": "7-g46b5ba42",
    "semverString": "2.53.0+7.g46b5ba42",
    "version": "2.4.1"
};
/* tslint:enable */
